import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { CompanyAuditAddComponent } from "app/company-audit/component/company-audit-add/company-audit-add.component";
import { CompanyAuditUpdateComponent } from "app/company-audit/component/company-audit-update/company-audit-update.component"
import { CompanyAuditDetailsComponent } from "app/company-audit/component/company-audit-details/company-audit-details.component";
import { CompanyAuditListComponent } from 'app/company-audit/component/company-audit-list/company-audit-list.component';
import { CompanyAuditModuleComponent } from 'app/company-audit/component/company-audit-module/company-audit-module.component';
import { CompanyAuditModuleViewComponent } from './component/company-audit-module-view/company-audit-module-view.component';
import { RequestExternalAuditComponent } from './component/request-external-audit/request-external-audit.component';


export const COMPANY_AUDIT_ROUTES: Routes = [
    {
        path: 'company-audit',
        component: LayoutComponent,
        canActivate: [MsalGuard],
        children: [
            { path: '', component: CompanyAuditListComponent },
            { path: 'add', component: CompanyAuditAddComponent },
            { path: 'request-external', component: RequestExternalAuditComponent },
            { path: 'update/:id', component: CompanyAuditUpdateComponent },
            { path: ':id', component: CompanyAuditDetailsComponent },
            { path: 'audit/:auditId/:moduleId', component: CompanyAuditModuleComponent },
            { path: 'view/:auditId/:moduleId', component: CompanyAuditModuleViewComponent }
        ]
    }
];
